import {
  SET_USER,
  SET_AUTH_APPDATA_STATE,
  RESET_USER,
  UPDATE_BUILDING,
} from '../actions/types'

const authReducer = (state = {}, action) => {
  const { type, authenticated, payload } = action
  switch (type) {
    case SET_USER:
      return {
        authenticated,
        ...state,
        ...payload,
      }
    case SET_AUTH_APPDATA_STATE:
      return {
        ...state,
        ...{
          appData: {
            ...state.appData,
            ...{ buildings: payload },
          },
        },
      }
    case RESET_USER:
      return {}
    case UPDATE_BUILDING:
      return {
        ...state,
        ...{
          appData: {
            ...state.appData,
            ...{
              buildings: state.appData.buildings.map((item) => {
                // eslint-disable-line
                return item.id === payload.id ? payload : item
              }),
            },
          },
        },
      }
    default:
      return state
  }
}
export default authReducer
